import { defineAbility } from '@casl/ability';

export default defineAbility(() => {});
